'use strict';

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import DocumentTitle from '@uw-it-sis/lib-react/lib/DocumentTitle';

import { AiOutlineGoogle } from "react-icons/ai";

import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {withRouter} from "@uw-it-sis/lib-react/lib/WithRouter";
import {capitalize} from '@uw-it-sis/lib-react/lib/Utils';

import ImportSocialPlanConfirm from './ImportSocialPlanConfirm';
import importSocialPlanStore from './ImportSocialPlanStore';

class ImportSocialPlan extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = importSocialPlanStore;
    }

    componentDidMount() {
        if ( ! appStore.isSocialUser() && ! appStore.isAdviser() ) {
            this.store.mount()
        }
    }

    render() {
        let component;
        let params = this.props.params;

        if ( appStore.isSocialUser() || appStore.isAdviser() ) {
            // Info for social users and advisers if they find their way to this page
            component =
                <DocumentTitle title="Import Plan - MyPlan">
                    <>
                        <div className="page-heading">
                            <h1>Import Plan from Another Account</h1>
                        </div>
                        <div>
                            <p>If you're using MyPlan with a Google login, you will be able to import your academic
                                plan to your official UW account once you are accepted to the University of Washington. Note:
                                This will overwrite any plan you create with your UW NetID account.</p>
                            <p><a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/import-plan/" target="_blank">Learn more about
                                importing your plan</a>.</p>
                        </div>
                    </>
                </DocumentTitle>;
        } else {
            switch (params.state) {
                case "confirm":
                    component = <ImportSocialPlanConfirm/>;
                    break;
                default:
                    let importHistory;
                    if (this.store.history.dateImported) {
                        importHistory = (
                            <div className="mt-5">
                                <h2 className="h4">Last plan import</h2>
                                <Table borderless size="sm" className="w-auto">
                                    <thead>
                                    <tr>
                                        <th className="pb-1">Source</th>
                                        <th className="pb-1">Date & Time</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="pt-0">{capitalize(this.store.history.importedFrom)}</td>
                                        <td className="pt-0">{this.store.history.dateImported}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </div>
                        );
                    }

                    component =
                        <DocumentTitle title="Import Plan - MyPlan">
                            <>
                                <div className="page-heading">
                                    <h1>Import a Plan from Your Social Account</h1>
                                </div>
                                <div>
                                    <p>
                                        Choose the social account with plan items that you'd like to import.
                                        This will copy the planned courses, course placeholders, backup courses,
                                        and bookmarked courses from your social account, and overwrite the plan
                                        items in this NetID account.
                                    </p>
                                </div>
                                <div className="d-inline-flex flex-column d-grid gap-3 mt-5">
                                    <Button id="login-google" onClick={() => this.store.doLogin('google')} variant="google" className="d-flex align-items-center text-white">
                                        <AiOutlineGoogle aria-hidden={true} size={18} className="me-2"/>
                                        <span>Import from Google</span>
                                    </Button>
                                </div>
                                {importHistory}
                            </>
                        </DocumentTitle>;
            }
        }

        return component;
    }
}

export default withRouter(observer(ImportSocialPlan));